export default __webpack_public_path__ + "static/media/draft.b6826a07.svg";